import axios from '../plugins/axios'

export default {
  data() {
    return {
      loading: false,
      success: false,
      messageType: 'error',

      // plugin settings
      site_url: '',
      finish: '',
      px: 0,
      position_x: '',
      position_y: '',
    }
  },

  // initial data
  beforeMount() {
    const data = JSON.parse(this.$el.dataset.initial)

    for (const key in this.$data) {
      if (key in data) {
        this[key] = data[key]
      }
    }
  },

  methods: {
    update_plugin () {
      if (this.loading) {
        return
      }

      this.messageType = 'error'
      this.errors.clear()
      this.loading = true

      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false
          return
        }

        this.submit()
      })
    },

    submit () {
      const formData = new FormData(this.$el)

      axios.post('', formData)
        .then(response => {
          this.success = true
          this.loading = false

          this.messageType = 'success'
          this.errors.add({ msg: 'השינויים נשמרו בהצלחה.' })
        })
        .catch(error => {
          this.messageType = 'error'
          this.errors.add({ msg: error.response.data.data.message })
          this.loading = false
        })
    },
  },
}


// WEBPACK FOOTER //
// ./src/controllers/update_plugin.js